import styled from 'styled-components'

const PreviewContainer = styled.div`
  width: 600px;
  max-width: 70%;
  height: 400px;
`

export default PreviewContainer
